import { Tag } from '@servicetitan/design-system';
import { observer } from 'mobx-react';
import { FC, useMemo } from 'react';
import { EstimateContainerWebModel, EstimateStatus } from '../../../api/portal-dashboard.api';
import { ProposalStatus } from '../../../api/portal-estimates.api';
import {
    ProposalStatusColor,
    ProposalStatusTagSubtle,
    ProposalStatusText,
} from '../../../enums/proposal-status';

interface ProposalsListItemProps {
    proposal: EstimateContainerWebModel;
}

const getProposalStatus = (item: EstimateContainerWebModel): ProposalStatus => {
    return item.estimates.some(e => e.status === EstimateStatus.Sold)
        ? ProposalStatus.Accepted
        : ProposalStatus.Open;
};

export const ProposalsListItemStatus: FC<ProposalsListItemProps> = observer(props => {
    const { proposal } = props;

    const status = useMemo(() => {
        return getProposalStatus(proposal);
    }, [proposal]);

    return (
        <Tag subtle={ProposalStatusTagSubtle[status]} color={ProposalStatusColor[status]}>
            {ProposalStatusText[status]}
        </Tag>
    );
});
